"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3632,6235],{

/***/ 46235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);





var BlogsWithLoadMore = function(props) {
    var handleShowMore = function handleShowMore() {
        setDisplayNumber(function(prevPostNum) {
            return prevPostNum + loadMoreSize;
        });
        if (displayNumber + loadMoreSize >= (blogs === null || blogs === void 0 ? void 0 : blogs.length)) setIsAllLoaded(true);
        else setIsAllLoaded(false);
    };
    var handleShowLess = function handleShowLess() {
        setDisplayNumber(initSize);
        setIsAllLoaded(false);
    };
    var title = props.title, blogs = props.blogs, initSize = props.initSize, loadMoreSize = props.loadMoreSize;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isAllLoaded = ref[0], setIsAllLoaded = ref[1];
    // Initial display blogs
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(initSize), displayNumber = ref1[0], setDisplayNumber = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if ((blogs === null || blogs === void 0 ? void 0 : blogs.length) < initSize) {
            setDisplayNumber(blogs.length);
            setIsAllLoaded(true);
        } else {
            setDisplayNumber(initSize);
            setIsAllLoaded(false);
        }
    }, [
        blogs
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "additional-posts",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "section-heading",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row justify-content-center g-3",
                        children: (blogs === null || blogs === void 0 ? void 0 : blogs.length) && (blogs === null || blogs === void 0 ? void 0 : blogs.slice(0, displayNumber).map(function(blog) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-4 col-md-6 col-sm-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "card steps-card",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            sizes: "(max-width: 375px) 295px, (max-width: 576px) 265px, (max-width: 768px) 355px, (max-width: 992px) 310px, (max-width: 1280px) 370px",
                                            className: "card-img-top w-100",
                                            src: (blog === null || blog === void 0 ? void 0 : (ref = blog.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Thumbnail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.url) || "",
                                            alt: (blog === null || blog === void 0 ? void 0 : (ref4 = blog.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Thumbnail) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.alternativeText) || (blog === null || blog === void 0 ? void 0 : (ref8 = blog.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Thumbnail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.name),
                                            width: "370",
                                            height: "155"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "card-body",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    className: "card-title",
                                                    children: blog === null || blog === void 0 ? void 0 : (ref12 = blog.attributes) === null || ref12 === void 0 ? void 0 : ref12.Title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "card-text",
                                                    children: blog === null || blog === void 0 ? void 0 : (ref13 = blog.attributes) === null || ref13 === void 0 ? void 0 : ref13.Excerpt
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "card-footer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/blog/[slug]",
                                                as: "/blog/".concat(blog === null || blog === void 0 ? void 0 : (ref14 = blog.attributes) === null || ref14 === void 0 ? void 0 : ref14.Slug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "link",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        id: "blogs-read-more"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, blog === null || blog === void 0 ? void 0 : (ref15 = blog.attributes) === null || ref15 === void 0 ? void 0 : ref15.Slug);
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row mt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-lg-12 text-center",
                            children: [
                                !isAllLoaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: handleShowMore,
                                    className: "btn btn-primary btn-lg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        id: "blogs-load-more"
                                    })
                                }),
                                isAllLoaded && (blogs === null || blogs === void 0 ? void 0 : blogs.length) > initSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: handleShowLess,
                                    className: "btn btn-outline-primary btn-lg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        id: "show-less"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogsWithLoadMore);


/***/ })

}]);